import React, { useState } from 'react'
import RecordingUsage from '@Components/MatchComponents/MatchRecordingGroups/MatchingRecordingGroupsTable/RecordingUsage'
import { ICONS } from '@Const/common'
import MatchDetailsTable from '@Components/MatchComponents/MatchDetailsTable'
import clsx from 'clsx'
import { RecordingGroup } from '@Entities/matching/recording-group-details'
import SelectToggle from '@Components/MatchComponents/MatchRecordingGroups/MatchingRecordingGroupsTable/MatchRecordingGroupsRow/SelectToggle'

interface MatchRecordingGroupsRowProps {
    result: RecordingGroup
    selected: boolean
    deselect: (id: string) => void
    select: (id: string) => void
}

const MatchRecordingGroupsRow = (props: MatchRecordingGroupsRowProps) => {
    const { result, selected, deselect, select } = props
    const [isExpanded, setIsExpanded] = useState(false)

    return (
        <>
            <div className={clsx('results-row', result.matchingSuggestionStatus && 'disabled')}>
                <p>{result.isrc}</p>
                <p>{result.title}</p>
                <p>{result.artist}</p>
                <p>{result.writers}</p>
                <RecordingUsage recordings={result.recordings} recordingGroupId={result.id} />
                <p>{'$'.repeat(result.unmatchedAmount)}</p>
                <div className="icons">
                    <img
                        className={clsx(isExpanded ? 'chevron-icon-expanded' : 'chevron-icon')}
                        src={ICONS.chevron_drop_down}
                        onClick={() => setIsExpanded(!isExpanded)}
                        alt={isExpanded ? 'contract' : 'expand'}
                    />
                    {result.matchingSuggestionStatus ? (
                        <div className="submitted-text">Submitted</div>
                    ) : (
                        <SelectToggle selected={selected} id={result.id} select={select} deselect={deselect} />
                    )}
                </div>
            </div>
            {isExpanded && (
                <div className="expand-details" key={`${result.id}-details`}>
                    <MatchDetailsTable recordings={result.recordings} />
                </div>
            )}
        </>
    )
}

export default MatchRecordingGroupsRow
